export const env = {
  // From CI environment
  CI_BUILDNUMBER: process.env.NX_CI_BUILDNUMBER || process.env.NX?.NX_CI_BUILDNUMBER || 'UNSET',
  CI_BUILDID: process.env.NX_CI_BUILDID  || process.env.NX?.NX_CI_BUILDID || 'UNSET',
  CI_GIT_SHA: process.env.NX_CI_GIT_SHA || process.env.NX?.NX_CI_GIT_SHA || 'UNSET'
}
